import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

type InputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  type: 'text' | 'email' | 'password' | 'textarea' | 'date' | 'file';
  // name: string;
  label?: string | JSX.Element;
  // defaultValue?: string | null;
  // autoComplete?: string;
  // autoFocus?: boolean;
  // required?: boolean;
  error?: string;
  height?: string;
  // onBlur?: (event: any) => void;
  options?: string;
};

export default function Input(props: InputProps) {
  let {
    type,
    name,
    label,
    defaultValue,
    autoComplete,
    autoFocus,
    required,
    error,
    height,
    onBlur,
    options,
    className,
  } = props;
  const [inputType, setInputType] = useState(type);
  useEffect(() => {
    setInputType(type);
  }, [type]);

  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium text-gray-700"
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="mt-1">
        {type === 'textarea' ? (
          <textarea
            id={name}
            name={name}
            defaultValue={defaultValue ?? ''}
            required={required}
            autoComplete={autoComplete}
            autoFocus={autoFocus}
            className={clsx(
              height ?? 'h-64',
              'block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-accent-light focus:outline-none focus:ring-accent-light sm:text-sm',
            )}
            onBlur={onBlur}
            data-autotyper-options={options}
          />
        ) : (
          <div className="relative mt-1 rounded-md border border-gray-300 shadow-sm">
            <input
              {...props}
              type={inputType}
              id={name}
              name={name}
              defaultValue={defaultValue ?? ''}
              required={required}
              autoComplete={autoComplete}
              autoFocus={autoFocus}
              className={clsx(
                `block w-full rounded-md border-0 py-1.5 pl-3 text-gray-900 ring-1 ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-accent-light sm:text-sm sm:leading-6`,
                type === 'password' && 'pr-10',
                type !== 'password' && 'pr-3',
              )}
              //className="block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-0 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              onBlur={onBlur}
              data-autotyper-options={options}
            />

            {type === 'password' && (
              <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                <IconButton
                  className="h-5 w-5 text-gray-400"
                  aria-label="delete"
                  title={
                    inputType === 'text' ? 'Hide password' : 'Show password'
                  }
                  onClick={() =>
                    setInputType(inputType === 'text' ? 'password' : 'text')
                  }
                >
                  {inputType === 'text' && <VisibilityOff />}
                  {inputType === 'password' && <Visibility />}
                </IconButton>
              </div>
            )}
          </div>
        )}
        {error && <div className="mt-2 text-sm text-red-600">{error}</div>}
      </div>
    </div>
  );
}
